import React, { Fragment, useRef, useState } from "react";
import CustomTable from "../../common/CustomTable/CustomTable";
import ActionBar from "../../common/ActionBar";
import _ from "lodash";
import queryString from "query-string";
import labels from "../../../helpers/labels.json";
import { useSnackbar } from "notistack";
import { getErrorMessage, parseTimeStamp } from "../../../helpers/functions";
import TranscriberService from "../../../services/TranscriberService";
import styled from "styled-components";
import moment from "moment";
import { navigate } from "@reach/router";
import {
  DeleteButtonContainer,
  DeleteIcon,
} from "../../internal/NeutalMeeting/component/ArbitratorMeeting";

async function getLiveTranscription(query = "") {
  try {
    const response = await TranscriberService.getLiveTranscription(query);
    return { ...response };
  } catch (error) {
    throw error;
  }
}

const TranscriptionDetails = () => {
  const [state, setState] = useState({});
  const MTRef = useRef();
  const { enqueueSnackbar } = useSnackbar();
  const placeholderText = "Search meeting";
  const breadcrumbs = ["Meeting Details", "Transcript"];

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "meeting_details":
        navigate(`/dashboard/case-manager/meeting-details`);
        break;
      default:
        break;
    }
  };

  async function movedTranscription(id) {
    try {
      const response = await TranscriberService.movedTranscription({
        id: id,
      });
      enqueueSnackbar(response?.message, {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(getErrorMessage(error), {
        variant: "error",
      });
    } finally {
      MTRef.current.onQueryChange("");
    }
  }

  const columns = [
    {
      field: "caseId",
      title: "Case Id",
      sorting: false,
      render: (rowData) => <>{rowData?.caseId}</>,
    },
    {
      field: "meetingId",
      title: "Meeting Id",
      sorting: false,
      render: (rowData) => <>{rowData?.meetingId}</>,
    },
    {
      field: "streamingKey",
      title: "Streaming Key",
      sorting: false,
      render: (rowData) => (
        <>{rowData?.streamingKey ? rowData?.streamingKey : "-"}</>
      ),
    },
    {
      field: "created_at",
      title: labels["created_on"],
      sorting: false,
      render: (rowData) => (
        <>{moment(parseTimeStamp(rowData.created_at)).format("DD/MM/YYYY")}</>
      ),
      cellStyle: {
        maxWidth: 100,
        width: 100,
        paddingLeft: "22px",
      },
    },
    {
      field: "updated_at",
      title: labels["updated_on"],
      sorting: false,
      render: (rowData) => (
        <>{moment(parseTimeStamp(rowData.updated_at)).format("DD/MM/YYYY")}</>
      ),
      cellStyle: {
        maxWidth: 100,
        width: 100,
        paddingLeft: "22px",
      },
    },
    {
      field: "actions",
      title: "Action",
      sorting: false,
      headerStyle: { textAlign: "center", width: "20%" },
      cellStyle: { padding: "12px 16px", textAlign: "center" },
      render: (rowData) => (
        <DeleteButtonContainer onClick={() => movedTranscription(rowData.id)}>
          <DeleteIcon>✕</DeleteIcon>
        </DeleteButtonContainer>
      ),
    },
  ];

  const data = (query) =>
    new Promise((resolve) => {
      let params = {
        page: query.page + 1,
        perPage: 10,
      };
      if (query.orderBy?.field) {
        params.sort = query.orderBy.field;
        params.sortDirection = query.orderDirection;
      }
      if (query?.search) {
        params.query = query?.search;
      }
      let stringParams = "";
      if (!_.isEmpty(params)) {
        stringParams = `?${queryString.stringify(params)}`;
      }
      getLiveTranscription(stringParams)
        .then(async (result) => {
          if (result) {
            resolve({
              data: result.data,
              page: result.page - 1,
              total: result.total,
            });
            setState(result);
          }
        })
        .catch((error) => {
          enqueueSnackbar(getErrorMessage(error), {
            variant: "error",
          });
          setState({ data: [], lastPage: 1, page: 1, perPage: 10, total: 0 });
          resolve({
            data: [],
            page: 0,
            total: 0,
          });
        });
    });

  return (
    <Fragment>
      <ActionBar {...{ breadcrumbs, onBreadcrumbClick }} />
      <Padding>
        <CustomTable
          hidePagination={state.lastPage === 1}
          pageSize={state?.data?.length ? state?.data?.length : 10}
          pluralTitle={labels.case_manager}
          hideFilterBar
          singularTitle=""
          {...{
            columns,
            data,
            MTRef,
            placeholderText,
          }}
          state={state}
        />
      </Padding>
    </Fragment>
  );
};

export default TranscriptionDetails;

export const Padding = styled.div`
  padding-top: 30px;
  padding-bottom: 50px;
  padding-left: 35px;
  padding-right: 53px;
`;
